export default "__VITE_ASSET__DTAT2KRw__"